<template>
    <v-layout row> 
        <v-flex xs12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-card>

            <announcements-banner></announcements-banner>

            <v-alert v-for="(item,index) in notifications_data" :key="index" :value="true" :color="item.alertType" :icon="item.icon" outline class="mt-2 mb-0 rounded-4">
                <span v-html="item.description" @click="navigateToPage(item)" class="alert-link"></span>
            </v-alert>

            <v-layout row wrap class="mt-0">

                <!-- My Dashboard - Mobile -->
                <v-expansion-panel v-if="isMobile" v-model="expandedPanels" expand>
                    <v-expansion-panel-content v-for="(item,i) in my_attendance_data.slice(0,7)" :key="i">
                        <template v-slot:header>
                            <b>{{ item.transDate | moment('MMM DD ddd') }} {{ item.isToday?' | Today':'' }}</b>
                            <v-spacer></v-spacer>
                        </template>
                        <v-card class="elevation-1">
                            <v-card-text class="subheading">
                                <v-layout row wrap @click="viewAttendance(item)">
                                    <v-flex xs4>
                                        <v-chip label color="primary" outline class="wp-100">
                                            WORKSHIFT
                                        </v-chip>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-chip v-if="item.clockStart" label :color="item.workshiftColor" class="wp-100">
                                            {{ item.clockStart | moment('h:mm a')}} - {{ item.clockEnd | moment('h:mm a')}}
                                        </v-chip>
                                         <v-chip v-else label color="primary" outline class="wp-100">
                                            <span class="red--text">No workshift</span>
                                        </v-chip>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap @click="viewAttendance(item)">
                                    <v-flex xs4>
                                        <v-chip label color="primary" outline class="wp-100">
                                            CLOCK IN
                                        </v-chip>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-chip v-if="!item.isToday || item.clockIn" label color="primary" outline class="wp-100">
                                            <b>{{ item.clockIn | moment('hh:mm a') }}</b>
                                        </v-chip>
                                        <v-btn v-if="item.isToday && item.needsClockIn && !item.clockIn" block class="primary clock-button" :disabled="!item.clockStart" title="Click to Clock-In">Clock-In</v-btn>   
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap @click="viewAttendance(item)">
                                    <v-flex xs4>
                                        <v-chip label color="primary" outline class="wp-100">
                                            CLOCK OUT
                                        </v-chip>                                            
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-chip v-if="!item.isToday || item.clockOut || item.needsClockOut" label color="primary" outline class="wp-100">
                                            <b>{{ item.clockOut | moment('hh:mm a') }}</b>
                                        </v-chip>
                                        <v-btn v-if="item.isToday && !incompleteClockHours && item.needsClockOut" block class="primary clock-button" title="Click to Clock-Out">Clock-Out</v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap @click="viewAttendance(item)">
                                    <v-flex xs4>
                                        <v-chip label color="primary" outline class="wp-100">
                                            CHARGEABLE
                                        </v-chip>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-chip label color="primary" outline class="wp-100">
                                            <b v-if="item.isToday && item.needsClockOut" :class="totalHoursClass">{{ totalHours }}</b>
                                            <b v-else>{{ item.chargeableHours }}</b>
                                        </v-chip>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap @click="viewAttendance(item)">
                                    <v-flex xs4>
                                        <v-chip label color="primary" outline class="wp-100">
                                            STATUS
                                        </v-chip>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-chip v-if="item.isToday && incompleteClockHours && (item.needsClockIn || item.needsClockOut)" label color="primary" outline class="wp-100">
                                            <b class="red--text">Incomplete Hours</b>
                                        </v-chip>
                                        <!-- handle midshift -->
                                        <v-btn v-else-if="isMidshiftAndClockedInYesterday(item)" block class="primary clock-button">Clock-Out</v-btn>
                                        <v-chip v-else label color="primary" outline class="wp-100">
                                            <b v-if="!item.needsClockIn && !item.needsClockOut" :class="`${item.remarksColor}`" title="Click to view Attendance Details">{{ item.remarks }}</b>
                                        </v-chip>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <!-- My Dashboard - Desktop -->
                <v-flex xs12 sm8 v-if="!isMobile">
                    <v-card class="elevation-1">
                        <v-toolbar flat height="40">
                            <span class="body-2">
                                Recent Time Logs
                            </span>
                            <v-spacer></v-spacer>
                            <v-btn icon small to="/myattendance/calendar" title="View all My Attendance">
                                <v-icon>far fa-calendar-alt</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-data-table
                            :headers="header_myattendance"
                            :items="my_attendance_data"
                            :loading="loading_myattendance"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSync"
                        >
                        <template v-slot:items="props">
                            <tr>
                                <td class="remarks" @click="viewAttendance(props.item)" title="Click to view Attendance Details">
                                    <div style="margin-left:-10px;">
                                        <v-chip small v-if="props.item.isToday">Today</v-chip>
                                        <v-chip small v-else>{{ props.item.transDate | moment('MMM DD ddd') }}</v-chip>
                                    </div>
                                </td>
                                <td>
                                    <v-chip v-if="props.item.clockStart" small :style="`background-color:${props.item.workshiftColor};`" class="user-chip-container">
                                        {{ props.item.clockStart | moment('h:mma')}} - {{ props.item.clockEnd | moment('h:mma')}}
                                    </v-chip>
                                    <span v-else class="red--text">No workshift</span>
                                </td>
                                <td class="remarks" @click="viewAttendance(props.item)" title="Click to view Attendance Details">{{ props.item.clockIn | moment('hh:mm a') }}</td>
                                <td class="remarks" @click="viewAttendance(props.item)" title="Click to view Attendance Details">{{ props.item.clockOut | moment('hh:mm a') }}</td>
                                <td class="remarks" @click="viewAttendance(props.item)" title="Click to view Attendance Details">
                                    <span v-if="props.item.isToday && props.item.needsClockOut" :class="totalHoursClass">{{ totalHours }}</span>
                                    <span v-else>{{ props.item.chargeableHours }}</span>
                                </td>
                                <td class="remarks" @click="viewAttendance(props.item)">
                                    <span v-if="props.item.isToday">
                                        <v-btn v-if="props.item.needsClockIn" small class="primary clock-button" title="Click to Clock-In" :disabled="!props.item.clockStart">Clock-In</v-btn>
                                        <span v-if="incompleteClockHours && !props.item.needsClockIn && props.item.needsClockOut" class="red--text">Incomplete Hours</span>
                                        <v-btn v-if="!incompleteClockHours && !props.item.needsClockIn && props.item.needsClockOut" small class="primary clock-button" title="Click to Clock-Out">Clock-Out</v-btn>
                                    </span>
                                    <span v-else-if="isMidshiftAndClockedInYesterday(props.item)">
                                        <!-- handle midshift -->
                                        <v-btn small class="primary clock-button" title="Click to Clock-Out">Clock-Out</v-btn>
                                    </span>
                                    <span v-else>
                                        <span v-if="!props.item.needsClockIn && !props.item.needsClockOut" :class="`${props.item.remarksColor}`" title="Click to view Attendance Details">{{ props.item.remarks }}</span>
                                    </span>
                                </td>
                            </tr>
                        </template>
                        </v-data-table> 
                    </v-card>
                </v-flex>

                <!-- My Favorites -->
                <v-flex xs12 sm4>
                    <v-card class="elevation-1">
                        <v-toolbar flat height="40">
                            <span class="body-2">
                                My Favorites
                            </span>
                        </v-toolbar>
                        <v-card-text>
                            <v-chip v-for="(item, index) in favorites" :key="index" @click="$router.push(`${item.pagePath}`)" >
                                <v-icon>{{ item.pageIcon }}</v-icon>
                                <span class="ml-5 clickable">{{ item.pageName }}</span>
                            </v-chip>
                        </v-card-text>
                    </v-card>
                </v-flex>

            </v-layout>
        </v-flex>
    </v-layout>
</template>
<script>

import myAttendanceApi from '@/api/myattendance'
import notificationsApi from '@/api/notifications'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {  
    name: 'MyDashboard',
    metaInfo: {
        title: 'My Dashboard',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'My Dashboard' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'announcements-banner': () => import('@/components/CompanyAnnouncements/CompanyAnnouncementsBanner'),
    },      
    data () {
        return {
            rowsPerPageItems,
            expandedPanels: [true],
            error: false,
            errorMessage: '',
            paginationSync: {rowsPerPage: userPrefs.getRowsPerPage(this.$route.name)},
            header_myattendance: [
                {text:'Date', align:'left', value:'', sortable:false},
                {text:'Workshift', align: 'left', value:'', sortable:false},
                {text:'Clock-In', align: 'left', value:'', sortable:false},
                {text:'Clock-Out', align: 'left', value:'', sortable:false},
                {text:'Chargeable', align: 'left',value: '', sortable:false},
                {text:'Status', align: 'left', value:'', sortable:false},
            ],
            currentDate: '',
            greetings: '',
            currentDateTimer: null,
            increment_timer: null,
            loading_myattendance: false,
            loading: false,
            my_attendance_data: [],
            totalHours: '',
            totalHoursValue: 0,
            totalMinutes: 0,
            totalHoursClass: '',
            refreshTriggered: false,
            notifications_data: []
        }
    },
    methods: { 
        navigateToPage(item) {
            //current reminder is for Timesheet only.
            //once other pages reminder are implemented, need to check Type to determine page
            this.$router.push(`/myattendance/timesheet/${item.cutOffId}/${item.userId}`)
        },
        viewAttendance(data) {
            // Midshift range: yesterday 4:00 PM to today (anytime)
            const now = this.$moment();
            const isToday = now.isSame(this.$moment(data.transDate), 'day')

            if (this.isMidshiftAndClockedInYesterday(data) || (isToday && (data.needsClockIn || data.needsClockOut))) {
                this.$router.push('/myattendance/daily');
            } else {
                this.$router.push(`/myattendance/daily/${this.$moment(data.transDate).format('YYYY-MM-DD')}`);
            }
        },
        isMidshiftAndClockedInYesterday(data) {
            const clockIn = data.clockIn ? this.$moment(data.clockIn) : null
            const clockOut = data.clockOut ? this.$moment(data.clockOut) : null
            const now = this.$moment();

            const yesterdayAt4PM = now.clone().subtract(1, 'day').hour(16).minute(0).second(0)
            const todayStart = now.clone().startOf('day');
            
            const isMidshift = clockIn &&
                clockIn.isSameOrAfter(yesterdayAt4PM) &&
                clockIn.isBefore(todayStart) &&
                !clockOut;
            return isMidshift
        },
        isToday(date) {
            return this.$moment(date).format('YYYY-MM-DD') == this.$moment(new Date()).format('YYYY-MM-DD')
        },
        computeTotalHoursToday() {
            var totalHours = '0'
            var totalMins = '0'
            var totalSecs = '0'
            this.totalHours = ''
            
            if (this.clockInToday) {
                var duration = this.$moment.duration(this.$moment(new Date()).diff(this.$moment(this.clockInToday)))
                totalHours = duration.hours()
                totalMins = duration.minutes()
                totalSecs = duration.seconds()

                this.totalHoursValue = duration.hours()
                this.totalMinutes = duration.minutes()
                this.totalHours = `${totalHours}:${totalMins}:${totalSecs}`
                this.totalHoursClass = totalHours >= 9 ? 'green--text' : 'red--text'
            }    
        },
        showGreetings() {  
            this.currentDate = Date()
                
            if (this.$moment(this.currentDate).format("a")=='am')
                this.greetings = `Good morning, ${this.$store.state.firstName}!`
            else {
                if (this.$moment(this.currentDate).format("HHmm") >= '1200')
                    this.greetings = `Good afternoon, ${this.$store.state.firstName}!`
                if (this.$moment(this.currentDate).format("HHmm") >= '1800')
                    this.greetings = `Good evening, ${this.$store.state.firstName}!`
            }
        },   
        async getMyAttendance() {
            try {
                this.loading_myattendance = true
                const response = await myAttendanceApi.getPastWeek()
                if (response && response.status == 200) {
                    this.my_attendance_data = response.data.items
                }
                this.loading_myattendance = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getMyReminders() {
            try {
                const response = await notificationsApi.getMyReminders()
                if (response && response.status == 200) {
                    this.notifications_data = response.data.reminders
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    async created() {     
        this.showGreetings()
        this.getMyAttendance()
        this.getMyReminders()
        
        this.$root.$emit('setHeaderTitles', {
            display: true,
            isMainMenu: true,
            headerTitle: this.greetings,
            headerPageTitle: 'My Dashboard'
        })

        this.attendanceHubGroup = this.$store.state.teamId + 'AtttendanceHub_GroupName'
        this.increment_timer = setInterval(this.computeTotalHoursToday, 1000)
        this.currentDateTimer = setInterval(this.showGreetings, 3600000)
    },
    watch: {
        totalHoursValue(newVal) {
            if (newVal == 9 && !this.refreshTriggered) {
                this.getMyAttendance();
                this.refreshTriggered = true;
            }
        },
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal);
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
        favorites() {
            return this.$store.getters.favorites
        },
        clockInToday() {
            return this.my_attendance_data.filter(x => x.isToday)[0].clockIn
        },
        incompleteClockHours() {
            //requiredClockHours = company.hoursPerDay + workshift.breakTime
            return this.totalHoursValue < 9
        }
    },
    destroyed() {
        clearInterval(this.increment_timer)
        clearInterval(this.currentDateTimer)
    },
}
</script>
<style scoped>
.remarks{
    cursor: pointer;
}
.remarks:hover {
    text-decoration: underline;
}
.clock-button {
    margin:2px -3px 0px 3px;
}
.alert-link {
    cursor: pointer;
}
.alert-link:hover {
    text-decoration: underline;
}
</style>